import React, { useState } from 'react';
import { ANALYTICS_EVENTS, trackEvent } from '../../analytics';
import {
  Button,
  FormControl,
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Textarea,
  useDisclosure
} from '@chakra-ui/react';

const FineTuneProfileAction = ({
  person,
  creatingProfile = {},
  onRefreshProfile
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [roleDetails, setRoleDetails] = useState('');
  const personId = person?.personid;
  const isRefreshing = Boolean(personId && creatingProfile?.[personId]);
  const hasTtId = Boolean(person?.tt_id);

  if (!personId || person?.description == null) {
    return null;
  }

  const handleRefreshProfile = () => {
    if (!onRefreshProfile || isRefreshing) {
      return;
    }

    onClose();
    trackEvent(ANALYTICS_EVENTS.FINE_TUNE_STARTED);
    onRefreshProfile(personId, person, { roleDetails });
  };

  return (
    <>
      <Button
        colorScheme="blue"
        variant="outline"
        bg="transparent"
        _hover={{ bg: 'blue.50' }}
        leftIcon={isRefreshing ? undefined : <i className="bi bi-sliders" aria-hidden="true" />}
        onClick={onOpen}
        isDisabled={!onRefreshProfile || isRefreshing || !hasTtId}
        minW="110px"
      >
        {isRefreshing ? (
          <Spinner size="xs" color="blue.500" thickness="2px" speed="0.6s" />
        ) : (
          'Fine-tune'
        )}
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Fine-tune profile</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Tailor for this role</FormLabel>
              <Textarea
                value={roleDetails}
                onChange={(event) => setRoleDetails(event.target.value)}
                minH="180px"
                placeholder="Add role details..."
              />
            </FormControl>
          </ModalBody>
          <ModalFooter justifyContent="flex-start">
            <Button
              size="sm"
              colorScheme="blue"
              variant="outline"
              onClick={handleRefreshProfile}
              isDisabled={!onRefreshProfile || isRefreshing}
            >
              Refresh Profile
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default FineTuneProfileAction;
